import styles from './SaveSearchWrapper.less';

import React, { Component, PropTypes } from 'react';
import SaveSearch from './SaveSearch';

class SaveSearchWrapper extends Component {
  static propTypes = {
    prompt: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }

  render() {
    const { description, prompt } = this.props;
    return (
      <section className={styles.root} data-automation="savePanel">
        <h1 className={styles.savePrompt}>{prompt}</h1>
        <p className={styles.saveDescription}>{description}</p>
        <SaveSearch />
      </section>
    );
  }
}

export default SaveSearchWrapper;




/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanel/components/SaveSearch/SaveSearchWrapper.js
 **/